// extracted by mini-css-extract-plugin
export default {"main":"App_main__5VZ13","loadingScreen":"App_loadingScreen__T5qAm","layout":"App_layout__UNCUu"};